import { Avatar as MuiAvatar, useTheme } from '@mui/material';
import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import PeopleGroupIcon from '../../../../icons/PeopleGroupIcon';
import TopicChatIcon from '../../../../icons/TopicChatIcon';
import useTeceoStyles from '../../../../useTeceoStyles';
import { ChatType } from '../../types/chat.types';
import { isGroupChat, isTopicChat } from '../../utils/chat.utils';

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
  },
  icon: {
    position: 'absolute',
    bottom: '5%',
    right: theme.spacing(-1 / 2),
  },
  avatar: {
    alignSelf: 'center',
    border: `1px solid ${theme.palette.grey[200]}`,
  },
}));

interface ChatAvatarProps {
  src?: string;
  size?: number;
  title?: string;
  chatType?: ChatType;
  backgroundColor?: string;
}

const ChatAvatar = ({
  title,
  src,
  size = 4,
  backgroundColor = 'white',
  chatType,
}: ChatAvatarProps) => {
  const theme = useTheme();
  const { classes: teceoClasses } = useTeceoStyles();
  const { classes, cx } = useStyles();

  const Avatar = () => (
    <MuiAvatar
      src={src}
      className={cx(teceoClasses.secondaryTypography, classes.avatar)}
      style={{
        backgroundColor,
        width: theme.spacing(size),
        height: theme.spacing(size),
        textTransform: 'capitalize',
      }}
    >
      {title && title.length > 0 ? title[0] : ''}
    </MuiAvatar>
  );

  if (chatType && (isGroupChat(chatType) || isTopicChat(chatType))) {
    return (
      <div className={classes.root}>
        <Avatar />

        {isGroupChat(chatType) ? (
          <PeopleGroupIcon fontSize="small" className={classes.icon} />
        ) : (
          <TopicChatIcon fontSize="small" className={classes.icon} />
        )}
      </div>
    );
  }

  return <Avatar />;
};

export default memo(ChatAvatar);
